import { Button, InputSearch } from '@/components/elements';
import { CommentList } from '@/components/elements/CommentList';
import { useAdminComments } from '@/hooks/useAdminComments';
import { closeModal, openModal } from '@roc-digital/ui-lib';
import { ConfirmDeleteModal, EditModal } from './Modals';
import { Comment } from "@roc-digital/types";

interface CommentsViewProps {
  userId?: string;
  articleId?: string;
}

export function CommentsView(props: CommentsViewProps) {
  const api = useAdminComments({
    user_id: props.userId,
    ref_id: props.articleId,
  });

  const onDelete = (comment: Comment) => {
    openModal(<ConfirmDeleteModal
      onCancel={closeModal}
      onConfirm={() => {
        closeModal();
        api.delete(comment)
      }}
    />, 'small')
  }

  const onEdit = (comment: Comment) => {
    openModal(<EditModal
      body={comment.body}
      onCancel={closeModal}
      onDelete={() => onDelete(comment)}
      onSave={(body) => {
        closeModal();
        api.edit(comment, body)
      }}
    />, 'small')
  }

  return <>
    <div className="flex flex-row mb-4 justify-between">
      <InputSearch
        showLoading={false}
        showLabel={false}
        value={api.query}
        placeholder={'Search Comments'}
        changeValueEvent={api.setQuery}
        hideResults
      />
    </div>
    <CommentList
      comments={api.comments}
      loading={api.loading}
      onEdit={onEdit}
    />
    <div className='flex flex-row justify-center pt-4'>
      <Button
        disabled={!api.canLoadMore}
        loading={api.loading}
        clickEvent={api.loadMore}
        size='sm'
      >Load More</Button>
    </div>
  </>
};

